import { useEffect, useState } from 'react';
import { Landing } from './components/Landing';
import { QuizEntry } from './components/QuizEntry';

export function navigate(path: string) {
  history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

function usePath() {
  const [path, setPath] = useState(location.pathname);
  useEffect(() => {
    const on = () => setPath(location.pathname);
    window.addEventListener('popstate', on);
    return () => window.removeEventListener('popstate', on);
  }, []);
  return path;
}

export function App() {
  const path = usePath();
  const match = path.match(/^\/q\/([A-Za-z0-9]{4,10})\/?$/);
  if (match) return <QuizEntry key={match[1]} code={match[1]!.toUpperCase()} />;
  return <Landing />;
}
